import { render } from "./video.vue?vue&type=template&id=61bfebd1&scoped=true"
const script = {}

import "./video.vue?vue&type=style&index=0&id=61bfebd1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61bfebd1"

export default script